import React from 'react';
import './Projects.css';

const projects = [
  {
    title: 'Rajmaya Residency',
    desc: 'Premium residential complex with modern amenities',
    gradient: 'linear-gradient(135deg, #667eea, #764ba2)',
  },
  {
    title: 'Green Valley Township',
    desc: 'Eco-friendly township spread across 25 acres',
    gradient: 'linear-gradient(135deg, #f093fb, #f5576c)',
  },
  {
    title: 'Metro Business Hub',
    desc: 'State-of-the-art commercial complex in the city center',
    gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)',
  },
];

const Projects = () => {
  return (
    <section className="projects section" id="projects">
      <div className="container">
        <h2 className="section-title">Our Projects</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div className="project-card" key={index}>
              <div
                className="project-img"
                style={{ background: project.gradient }}
              ></div>
              <div className="project-info">
                <h3>{project.title}</h3>
                <p>{project.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
